export default __webpack_public_path__ + "static/media/summary.1349e840.jpg";